import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import { makeStyles } from '@material-ui/core/styles';
import { preorder } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(5),
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
}));

const Preface = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="article"
        container
      >
        <Grid
          item
          md={4}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardMedia
              alt={preorder.alt}
              className={classes.media}
              component="img"
              image={preorder.img}
              object-fit
              title={preorder.title}
            />
          </Paper>
        </Grid>
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paper}
          >
            <Typography variant="h1">
              Précommande
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Nous attendons le bon moment pour permettre aux utilisateurs de précommander SeedOut !
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Il vous sera bientôt possible de précommander le jeu. L' équipe travail d'arrache pied pour qu' une version béta soit bientot disponible qui permettra ensuite de mettre en place une prévente !
            </Typography>
            <Button
              color="secondary"
              disabled
              size="large"
              variant="contained"
            >
              Commandez le vôtre
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Preface;
